import React from 'react'
import { FormattedNumber as IntlFormattedNumber } from 'react-intl'
import { Box } from '@mui/material'

export default function FormattedCurrency({ value, align = 'right' }) {
  const numericValue = parseFloat(value)
  if (isNaN(numericValue)) return <>–</>

  return (
    <Box component="span" sx={{ display: 'inline-block', textAlign: align, width: '100%' }}>
      <IntlFormattedNumber
        value={numericValue}
        style="currency"
        currency="EUR"
      />
    </Box>
  )
}
